/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import '@babel/polyfill';

// Import all the third party stuff
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import App from './containers/App';

function Bookings({ }) {
  useEffect(() => {
    document.title = 'Bookings';
  }, []);

  return <App />;
}

export default connect(null, { })(Bookings);
